import styled from "styled-components";

// Internal Imports
import { COLORS } from "../../constants/colors";


// Wrapper
const DayOptionWrapper = styled.div<any>`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px;
        background-color: ${props => props.selected === true ? 'aliceblue' : COLORS.white_color1};
        font-size: 1em;
        color: ${COLORS.blue_main(1)};
        transition: all .2s;
        
        cursor: pointer;
        
        :hover {
          background-color: ${COLORS.white_color2(1)}
    }
`;

// Interface
interface Props {
    day: string;
    selected: boolean;
    onClick: () => void;
}

const DayOption = ({ day, selected, onClick }: Props) => {

    return (
        <DayOptionWrapper selected={selected} onClick={onClick}>
            {day}
        </DayOptionWrapper>
    );
}


export default DayOption;